import { UntypedFormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  public markFormGroupTouched(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.controls[key].markAsTouched();
      formGroup.controls[key].markAsDirty();
      if (formGroup.controls[key] && typeof formGroup.controls[key].value === 'string') {
        formGroup.controls[key].setValue(formGroup.controls[key].value.trim());
      }
      const mayBeFG = formGroup.controls[key] as UntypedFormGroup;
      if (mayBeFG.controls) {
        this.markFormGroupTouched(mayBeFG);
      }
    });
  }
  public SpaceValidation(event:any) {
    if(event.target.selectionStart === 0 && event.code==="Space"){
      event.preventDefault();
    }
  }
}
